import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const YouAreBeautiful = lazyWithPreload(
  () => import('./YouAreBeautiful'),
)
